import {
	deleteSubcategory,
	getSubcategories,
	saveSubcategory,
	updateSubcategory,
} from '@/services/community/reportsSubcategories'

export default {
	namespaced: true,
	state: {
		subcategoryList: {
			meta: {
				total: 0,
			},
		},
		subcategoriestatus: 'pending',
	},
	getters: {
		getSubcategoryList(state) {
			return state.subcategoryList
		},
		getSubcategoriestatus(state) {
			return state.subcategoriestatus
		},
	},
	mutations: {
		SET_SUBCATEGORY_LIST(state, value) {
			state.subcategoryList = value
		},
		SET_SUBCATEGORY_STATUS(state, value) {
			state.subcategoriestatus = value
		},
	},
	actions: {
		async fetchSubcategories({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SET_SUBCATEGORY_STATUS', 'pending')
			commit('SET_SUBCATEGORY_LIST', {
				meta: {
					total: 0,
				},
			})
			try {
				const { data } = await getSubcategories(params)
				commit('SET_SUBCATEGORY_STATUS', 'init')
				commit('SET_SUBCATEGORY_LIST', data)
				return data
			} catch (error) {
				commit('SET_SUBCATEGORY_STATUS', 'init')
				throw error
			}
		},

		async deleteSubcategoryRecord({ commit }, params) {
			commit('SET_SUBCATEGORY_STATUS', 'pending')
			try {
				const { data } = await deleteSubcategory(params)
				commit('SET_SUBCATEGORY_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SUBCATEGORY_STATUS', 'init')
				throw error
			}
		},
		async saveSubcategory({ commit }, params) {
			commit('SET_SUBCATEGORY_STATUS', 'pending')
			try {
				const { data } = await saveSubcategory(params)
				commit('SET_SUBCATEGORY_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SUBCATEGORY_STATUS', 'init')
				throw error
			}
		},
		async updateSubcategory({ commit }, params) {
			commit('SET_SUBCATEGORY_STATUS', 'pending')
			try {
				const { data } = await updateSubcategory(params)
				commit('SET_SUBCATEGORY_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SUBCATEGORY_STATUS', 'init')
				throw error
			}
		},
	},
}
